import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Fade from 'WeployDesignLanguage/transitions/Fade';
import { OverflowMenuButton, FaceIcon } from 'LegacyWeployDesignLanguage/icons';
import Card from 'WeployDesignLanguage/Card';
import Menu, { MenuItem } from 'WeployDesignLanguage/Menu';

const StyledCard = styled(Card)`
  margin: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: ${props => props.theme.spacing[2]} ${props => props.theme.spacing[1]} ${props => props.theme.spacing[5]};
`;

const IconContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: ${props => props.theme.space.half};
`;

const ButtonBar = styled.div`
  display: flex;
  margin-top: auto;
  flex-direction: row-reverse;
`;


const CircularIconWrapper = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.gray};
  border-radius: 50%;
  color: #00a890;
  display: flex;
  height: 60px;
  justify-content: center;
  width: 60px;
`;

const Name = styled.h6`
  margin-top: ${props => props.theme.space.half};
  margin-bottom: ${props => props.theme.space.single};
  text-align: center;
`;

const EmptyMessage = styled.p`
  margin-top: ${props => props.theme.space.half};
  margin-bottom: ${props => props.theme.space.single};
  text-align: center;
  color: ${props => props.theme.colors.disabled};
`;

const StyledFaceIcon = styled(FaceIcon)`
    color: ${props => props.theme.colors.darkerGrey};
    height: 40px;
    width: 40px;
`;

const StyledOverflowMenuContainer = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
`;

const EmptyPositionCard = ({ onCancelClick, position, showCancelMenuItem }) => {
  const [menuAnchorElement, setMenuAnchorElement] = React.useState(null);
  const open = Boolean(menuAnchorElement);

  const handleMenuClick = event => (
    setMenuAnchorElement(event.currentTarget)
  );

  const handleMenuClose = () => (
    setMenuAnchorElement(null)
  );

  const menuItems = [
    position.isCancellable && <MenuItem key={1} onClick={() => onCancelClick(position.id)}>Cancel</MenuItem>,
  ].filter(Boolean);

  return (
    <StyledCard>
      <div>
        <IconContainer>
          <CircularIconWrapper>
            <StyledFaceIcon />
          </CircularIconWrapper>
        </IconContainer>
        <Name>Weployee</Name>
      </div>
      <EmptyMessage>A Weployee will show up here once they are matched</EmptyMessage>
      { showCancelMenuItem && !!menuItems.length &&
        <ButtonBar>
          <StyledOverflowMenuContainer>
            <Menu
              id="fade-menu"
              anchorEl={menuAnchorElement}
              keepMounted
              open={open}
              onClose={handleMenuClose}
              TransitionComponent={Fade}
            >
              {menuItems.map(item => item)}
            </Menu>
            <OverflowMenuButton onClick={handleMenuClick} />
          </StyledOverflowMenuContainer>
        </ButtonBar>
      }
    </StyledCard>
  );
};

EmptyPositionCard.propTypes = {
  showCancelMenuItem: PropTypes.bool.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  position: PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.string,
    finishTime: PropTypes.string,
    extendable: PropTypes.bool,
    weployeeId: PropTypes.string,
    jobId: PropTypes.string,
    statusMessages: PropTypes.arrayOf(PropTypes.string),
    timesheetIds: PropTypes.arrayOf(PropTypes.string),
    isCancellable: PropTypes.bool.isRequired,
  }),
};

EmptyPositionCard.defaultProps = {
  position: {
    id: '',
    status: '',
    finishTime: '',
    extendable: false,
    weployeeId: '',
    jobId: '',
    statusMessages: [],
    timesheetIds: [],
  },
};

export default EmptyPositionCard;
